// @ts-nocheck
import { innerSearch } from 'api/Api';
import LoadingIndicator from 'app/components/LoadingIndicator';
import React, { useCallback, useEffect, useState } from 'react';
import { isIOS } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

const WechatMobProcess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const searchParams = useLocation().search;
  const paramPayUrl = new URLSearchParams(searchParams).get('payUrl');
  const paramTid = new URLSearchParams(searchParams).get('tid');
  const paramIsOa = new URLSearchParams(searchParams).get('isOa');
  const paramData = new URLSearchParams(searchParams).get('data');
  const redirectUrl = new URLSearchParams(searchParams).get('redirectUrl');
  const [apiRequestInterval, setApiRequestInterval] = useState(true);
  const [invokeData, setInvokeData] = useState(null);
  const initialTime = 120;
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const [message, setMessage] = useState('');

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
      .toString()
      .padStart(2, '0')}`;
  };

  const transactPolling = useMutation(() => innerSearch(paramTid), {
    onSuccess: data => {
      const returnUrl = data.data.returnUrl;
      const response = data.data.response;

      //Status 예외처리
      if (
        response.resultStatus === null ||
        response.resultStatus === undefined
      ) {
        navigate('/error');
        return;
      } else if (response.resultStatus === 'SUCCESS') {
        createFormAndSubmit(response, returnUrl);
      } else if (response.resultStatus === 'PENDING') {
        return;
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  const createFormAndSubmit = (formData, returnUrl) => {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', `${returnUrl}`);
    form.style.display = 'none';
    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', key);
      input.setAttribute('value', String(value));
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };

  const onBridgeReady = useCallback(data => {
    if (!data || !window.WeixinJSBridge) return;

    WeixinJSBridge.invoke('getBrandWCPayRequest', data, function (res) {
      // if (res) {
      //   navigate(`/mobile/wechat/result?tid=${paramTid}`);
      // }
      // console.log('결제 응답:', res);
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        setMessage(res.err_msg);
        navigate(`/mobile/wechat/result?tid=${paramTid}`);
        // 필요 시 리디렉션 또는 상태 업데이트
      } else {
        setMessage(res.err_msg);
        const cancelUrl = `${redirectUrl}?returnValue=${res.err_msg}`;
        window.location.href = cancelUrl;
      }
    });
  }, []);

  useEffect(() => {
    if (timeLeft > 0) {
      const timerId = setInterval(() => {
        setTimeLeft(prevTime => prevTime - 1);
      }, 1000);

      return () => clearInterval(timerId);
    }
  }, [timeLeft]);

  useEffect(() => {
    const interval = setTimeout(() => {
      transactPolling.mutate();
      setApiRequestInterval(false);
    }, 5000);

    return () => {
      if (!apiRequestInterval) {
        clearTimeout(interval);
      }
    };
  }, [apiRequestInterval]);

  useEffect(() => {
    // 5초마다 API 요청을 보냄
    if (timeLeft <= 120 && timeLeft > 0) {
      setApiRequestInterval(true);
    } else if (timeLeft === 0) {
      navigate(`/mobile/wechat/result?tid=${paramTid}`);
      setApiRequestInterval(false);
    } else {
      setApiRequestInterval(false);
    }
  }, [timeLeft, apiRequestInterval]);

  useEffect(() => {
    if (paramPayUrl) {
      window.sessionStorage.setItem('wechatSubmit', 'submitted');
      setTimeout(() => {
        window.location.replace(decodeURIComponent(paramPayUrl));
      }, 1000);
    }
    if (paramIsOa && paramData) {
      const parsed = JSON.parse(decodeURIComponent(paramData));
      setInvokeData(parsed);
    }
  }, []);

  //  invokeData가 준비된 후 브리지 준비 상태 확인 및 처리
  useEffect(() => {
    if (!invokeData) return;

    const handleBridge = () => onBridgeReady(invokeData);

    if (typeof WeixinJSBridge === 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', handleBridge, false);
        return () =>
          document.removeEventListener('WeixinJSBridgeReady', handleBridge);
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', handleBridge);
        document.attachEvent('onWeixinJSBridgeReady', handleBridge);
        return () => {
          document.detachEvent('WeixinJSBridgeReady', handleBridge);
          document.detachEvent('onWeixinJSBridgeReady', handleBridge);
        };
      }
    } else {
      handleBridge();
    }
  }, [invokeData, onBridgeReady]);

  if (isIOS && paramIsOa === 'N')
    return (
      <>
        <div
          style={{
            flexDirection: 'column',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            paddingTop: 50,
          }}
        >
          <>
            <img
              src="/image/common/schemeList/CN/WECHAT-QR.png"
              alt=""
              width={200}
              style={{ marginBottom: 20 }}
            />
            <div
              style={{
                color: timeLeft <= 30 ? 'red' : 'gray',
                marginTop: 20,
              }}
            >
              {t('scan_qr_code')} {formatTime(timeLeft)}
            </div>
          </>
        </div>
      </>
    );
  else if (paramIsOa === 'Y') {
    return <LoadingIndicator />;
  } else {
    return <>In Process...</>;
  }
};

export default WechatMobProcess;
